module.exports = __webpack_public_path__ + "assets_1713491368921/img/pic.cd38b695.png";